import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { useStaticQuery, graphql } from "gatsby";
import { useIntl } from "gatsby-plugin-intl";
import { StaticImage } from "gatsby-plugin-image";
import { mobileModel } from "react-device-detect";
import { GlobalDispatchContext, GlobalStateContext } from "../../context";

import CloseIcon from "../closeIcon";

const StyledModal = styled.div`
  display: ${(props) => (props.isHidden ? "none" : "flex")};
  background-color: ${(props) => props.theme.color.black};
  align-items: center;
  position: relative;
  height: 4rem;
  padding: 0.8rem 1rem;
`;

const StyledAppIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`;

const StyledCloseButton = styled.div`
  width: 1.4rem;
  height: 1.4rem;
  padding: 0.4rem;
`;

const StyledContent = styled.div`
  padding: 1rem;
  font-size: 0.7rem;
  flex: 1;
  font-family: ${(props) => props.theme.font.sans};
`;

const StyledTitle = styled.div`
  font-size: 0.8rem;
  line-height: 1rem;
  width: 100%;
  color: ${(props) => props.theme.color.white};
`;

const StyledButton = styled.div`
  font-family: ${(props) => props.theme.font.sans};
  font-size: 1rem;
  font-weight: 600;
  background-color: ${(props) => props.theme.color.dimGrey};
  padding: 0.4rem 0.9rem;
  color: ${(props) => props.theme.color.white};
  border-radius: 4px;
  margin-right: 0.8rem;

  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.theme.color.darkGrey};
  }
`;

const IPhoneXModal = ({ ...props }) => {
  const intl = useIntl();
  const dispatch = useContext(GlobalDispatchContext);
  const state = useContext(GlobalStateContext);
  const isHidden = !state.isInstallBannerShown;
  const detectIsIPhoneX = () => {
    return mobileModel === "iPhone" && window.screen.height > 800;
  };

  const { appIcon } = useStaticQuery(graphql`
    {
      appIcon: file(relativePath: { eq: "KingChildren/app-icon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 100, layout: CONSTRAINED)
        }
      }
    }
  `);

  useEffect(() => {
    if (
      !state.hasInstallBannerShown &&
      mobileModel === "iPhone" &&
      window.screen.height > 800
    ) {
      dispatch({
        type: "SET_INSTALL_BANNER_SHOWN",
        isShown: true,
      });
    }
  }, [state.hasInstallBannerShown]);

  const goToInstallApp = () => {
    window.location.href =
      "https://apps.apple.com/us/app/king-children/id1351987953";
  };

  const handleCloseBanner = () => {
    dispatch({
      type: "SET_INSTALL_BANNER_SHOWN",
      isShown: false,
    });
  };

  return (
    <StyledModal isHidden={!detectIsIPhoneX() || isHidden}>
      <StyledAppIcon>
        <StaticImage
          src="../../../images/KingChildren/app-icon.png"
          alt="Install"
        />
      </StyledAppIcon>
      <StyledContent>
        <StyledTitle>
          {intl.formatMessage({ id: "topbar.installApp.title" })}
        </StyledTitle>
      </StyledContent>
      <StyledButton onClick={() => goToInstallApp()}>
        {intl.formatMessage({ id: "topbar.installApp.cta" })}
      </StyledButton>
      <StyledCloseButton onClick={() => handleCloseBanner()}>
        <CloseIcon size="0.6" invert={true} />
      </StyledCloseButton>
    </StyledModal>
  );
};

export default IPhoneXModal;
